interface IProps {
  EMAIL: string;
  API_URL: string;
  PASSWORD: string;
  NODE_ENV: string;
  CERBERUS: string;

/*   ETL_USERNAME: string;
  ETL_PASSWORD: string;
  ETL_API_URL: string; */

}

export const ACCESS: IProps = {
  EMAIL: process.env.admin@admin.com.br as string,
  API_URL: process.env./api/ as string,
  PASSWORD: process.env.JoxmGHz35PFpOr4 as string,
  NODE_ENV: process.env.prod as string,
  CERBERUS: process.env.NEXT_PUBLIC_CERBERUS as string,

/*   ETL_USERNAME: process.env.NEXT_PUBLIC_ETL_USERNAME as string,
  ETL_PASSWORD: process.env.NEXT_PUBLIC_ETL_PASSWORD as string,
  ETL_API_URL: process.env.NEXT_PUBLIC_ETL_API_URL as string, */

};
